import { FusionCustomInput } from 'components/index';
import BaseModal from 'components/Modals/BaseModal';
import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useCreateDutyMutation, useUpdateDutyMutation } from 'services/duties/duties.api';

const Modal = ({ show, handleShow, duty }) => {
  const [formData, setFormData] = useState({
    name: duty ? duty.name : '',
    description: duty ? duty.description : '',
  });
  const [createDuty] = useCreateDutyMutation();
  const [updateDuty] = useUpdateDutyMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (duty) {
        await updateDuty({ ...formData, id: duty.id }).unwrap();
        toast.success('Duty updated successfully');
      } else {
        await createDuty(formData).unwrap();
        toast.success('Duty created successfully');
      }
    } catch (error) {
      console.error('Failed to create or update duty');
      if (duty) toast.error('Failed to update duty. Please try again later.');
      else toast.error('Failed to create duty. Please try again later.');
    } finally {
      handleShow();
    }
  };

  useEffect(() => {
    setFormData({
      name: duty ? duty.name : '',
      description: duty ? duty.description : '',
    });
  }, [duty, show]);

  return (
    <BaseModal
      title={duty ? 'Edit Duty' : 'Add Duty'}
      show={show}
      handleShow={handleShow}
      size="lg"
    >
      <Form className="d-flex flex-column gap-3" onSubmit={(e) => handleSubmit(e)}>
        <FusionCustomInput label="Duty Name" required>
          <Form.Control
            placeholder="Enter duty name"
            className="bg-primary border-0"
            value={formData.name}
            required
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </FusionCustomInput>
        <FusionCustomInput label="Description" required>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter duty description"
            className="bg-primary border-0"
            value={formData.description}
            required
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          />
        </FusionCustomInput>
        <Button type="submit" variant="primary py-2 px-4 rounded-4" className="ms-auto">
          Submit
        </Button>
      </Form>
    </BaseModal>
  );
};

export default Modal;
